import * as icon from "@coreui/icons";

export const singleCountriesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      const phone_code = item && item.phone_code
      const country_code = item && item.country_code
      if (phone_code) {
        options.push({
          label: name,
          value: JSON.stringify({
            id: id,
            name: name,
            icon: icon[`cif${country_code}`],
            phone_code: phone_code,
          })
        })
      }
    })
    options = [
      ...options,
    ]
  }
  return options
};

export const singleClientsOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      {
        label: 'Please select client...',
        value: '',
        isDisabled: true
      },
      ...options,
    ]
  }
  return options
}

export const singleProjectsOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      {
        label: 'Please select project...',
        value: '',
        isDisabled: true
      },
      ...options,
    ]
  }
  return options
}

export const singleExpenseIntervalOptionSelect = (is_repeat) => {
  return [
    {
      label: 'Daily',
      value: 'daily'
    },
    {
      label: 'Weekly',
      value: 'weekly'
    },
    {
      label: 'Monthly',
      value: 'monthly'
    },
    {
      label: 'Yearly',
      value: 'yearly'
    },
    {
      label: 'No repeat',
      value: 'no repeat',
      isDisabled: is_repeat
    },
  ]
}

export const singlePeriodOptionSelect = () => {
  return [
    {
      label: 'Please select period...',
      value: ''
    },
    {
      label: 'Today',
      value: 'today'
    },
    {
      label: 'This week',
      value: 'weekly'
    },
    {
      label: 'This month',
      value: 'monthly'
    },
    {
      label: 'This year',
      value: 'yearly'
    }
  ]
}

export const singleGenderOptionSelect = () => {
  return [
    {
      label: 'Male',
      value: 'male'
    },
    {
      label: 'Female',
      value: 'female'
    }
  ]
}

export const singleStatusContractOptionSelect = () => {
  return [
    {
      label: 'Full time',
      value: 'full-time'
    },
    {
      label: 'Contract base',
      value: 'contract-base'
    },
    {
      label: 'Freelancer',
      value: 'freelancer'
    }
  ]
}

export const singleDegreeOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      const code = item && item.code
      options.push({
        label: code ? `${name} (${code})` : name,
        value: id
      })
    })
    options = [
      ...options,
    ]
  }
  return options
};

export const singleStatusContractProjectOptionSelect = () => {
  return [
    {
      label: 'Signed',
      value: true
    },
    {
      label: 'Not signed',
      value: false
    }
  ]
}

export const singleLetterNumberOptionSelect = () => {
  return [
    {
      label: 'Invoice letter',
      value: 'INV'
    },
    {
      label: 'Quotation letter',
      value: 'QUOT'
    },
    {
      label: 'External letter',
      value: 'EXT'
    },
    {
      label: 'Internal letter',
      value: 'INT'
    }
  ]
}

export const singleRolesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.title
      options.push({
        label: name,
        value: id
      })
    })
  }
  return options
}

export const singleEmployeesOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      {
        label: 'Please select employee...',
        value: '',
        isDisabled: true
      },
      ...options,
    ]
  }
  return options
}

export const singleCourierOptionSelect = () => {
  return [
    {
      label: 'Please select courier...',
      value: ''
    },
    {
      label: 'JNE',
      value: 'jne'
    },
    {
      label: 'TIKI',
      value: 'tiki'
    },
    {
      label: 'J&T',
      value: 'j&t'
    },
    {
      label: 'AntarAja',
      value: 'antaraja'
    },
    {
      label: 'Grab',
      value: 'grab'
    },
    {
      label: 'Gojek',
      value: 'gojek'
    },
    {
      label: 'Pos Indonesia',
      value: 'pos'
    }
  ]
}

export const singleExpenseCategoryOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}

export const singleExpenseTagsOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}

export const singleExpenseCategoryAirplaneOptionSelect = () => {
  return [
    {
      label: 'Garuda Indonesia',
      value: 'Garuda Indonesia'
    },
    {
      label: 'Lion Air',
      value: 'Lion Air',
    },
    {
      label: 'Super Air Jet',
      value: 'Super Air Jet',
    },
    {
      label: 'Citilink',
      value: 'Citilink',
    },
    {
      label: 'Pelita Air',
      value: 'Pelita Air',
    },
    {
      label: 'Batir Air',
      value: 'Batir Air',
    },
    {
      label: 'Transnusa',
      value: 'Transnusa',
    },
    {
      label: 'Wings Air',
      value: 'Wings Air',
    },
    {
      label: 'Air Asia',
      value: 'Air Asia',
    },
    {
      label: 'Sriwijaya Air',
      value: 'Sriwijaya Air',
    },
    {
      label: 'Nam Air',
      value: 'Nam Air',
    },
  ]
}

export const singleExpenseCategoryTransportOptionSelect = () => {
  return [
    {
      label: 'Gojek',
      value: 'Gojek'
    },
    {
      label: 'Grab',
      value: 'Grab'
    },
    {
      label: 'Bluebird',
      value: 'Bluebird'
    },
    {
      label: 'Regular taxi',
      value: 'Regular taxi'
    },
    {
      label: 'Rental',
      value: 'Rental'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singleExpenseCategoryFuelOptionSelect = () => {
  return [
    {
      label: 'Shell',
      value: 'Shell'
    },
    {
      label: 'Pertamina',
      value: 'Pertamina'
    },
    {
      label: 'BP',
      value: 'BP'
    },
    {
      label: 'VIVO',
      value: 'VIVO'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singleExpenseCategoryTripTypeOptionSelect = () => {
  return [
    {
      label: 'One way',
      value: 'One way'
    },
    {
      label: 'Return',
      value: 'Return'
    }
  ]
}

export const singleExpenseCategoryFlightOptionSelect = () => {
  return [
    {
      label: 'Flight website',
      value: 'Flight website'
    },
    {
      label: 'Traveloka',
      value: 'Traveloka'
    },
    {
      label: 'Tokopedia',
      value: 'Tokopedia'
    },
    {
      label: 'Tiket.com',
      value: 'Tiket.com'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singleExpenseCategoryTrainOptionSelect = () => {
  return [
    {
      label: 'Train website',
      value: 'Train website'
    },
    {
      label: 'Traveloka',
      value: 'Traveloka'
    },
    {
      label: 'Tokopedia',
      value: 'Tokopedia'
    },
    {
      label: 'Tiket.com',
      value: 'Tiket.com'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singlePaymentTempoOptionSelect = () => {
  return [
    {
      label: '15 days',
      value: '15 days'
    },
    {
      label: '20 days',
      value: '20 days'
    },
    {
      label: '30 days',
      value: '30 days'
    },
    {
      label: '60 days',
      value: '60 days'
    },
    {
      label: '90 days',
      value: '90 days'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singleExpenseCategoryAccomodationOptionSelect = () => {
  return [
    {
      label: 'Hotel website',
      value: 'Hotel website'
    },
    {
      label: 'Traveloka',
      value: 'Traveloka'
    },
    {
      label: 'Tokopedia',
      value: 'Tokopedia'
    },
    {
      label: 'Tiket.com',
      value: 'Tiket.com'
    },
    {
      label: 'Others',
      value: 'Others'
    },
  ]
}

export const singleTypeSalaryDetailOptionSelect = () => {
  return [
    {
      label: 'Earnings',
      value: false
    },
    {
      label: 'Deductions',
      value: true
    }
  ]
}

export const singlePolicyTypeOptionsSelect = (data) => {
  let options = []
  if (data && data.length > 0) {
    data.forEach((item) => {
      const id = item && item.id
      const name = item && item.name
      options.push({
        label: name,
        value: id
      })
    })
    options = [
      ...options,
    ]
  }
  return options
}

export const singleInvoiceStatusOptionSelect = () => {
  return [
    {
      label: 'Published',
      value: false
    },
    {
      label: 'Draft',
      value: true
    }
  ]
}

export const singleInvoiceStatusPaymentOptionSelect = () => {
  return [
    {
      label: 'Paid',
      value: true
    },
    {
      label: 'Not Paid',
      value: false
    }
  ]
}

export const singleMonthOptionSelect = () => {
  return [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' }
  ]
}

export const singleProjectProgressStatusOptionSelect = () => {
  return [
    { value: 'done', label: 'Done' },
    { value: 'inprogress', label: 'Inprogress' },
    { value: 'cancelled', label: 'Cancelled' },
  ]
}